import {
  Component,
  ViewChild,
  ElementRef,
  ViewEncapsulation
} from "@angular/core";

import { MediumEditor } from "../../../../../vendor/medium-editor/medium-editor";

import { BaseComponent } from "../_base.component";
import { FormGridWithRows } from "../../../form.interface";

/**
 * @ignore
 */
@Component({
  selector: "uex-input-texteditor",
  templateUrl: "./texteditor.component.html",
  styleUrls: [
    "../../../../../vendor/medium-editor/medium-editor.css",
    "../../../../../vendor/medium-editor/themes/flat.css"
  ],
  host: {
    class: "uex-input-texteditor"
  },
  encapsulation: ViewEncapsulation.None
})
export class InputTexteditorComponent extends BaseComponent<string> {
  @ViewChild("editable", { static: true }) editable: ElementRef;

  public editor: typeof MediumEditor;

  private _subscriptions: { event: string; listener: Function }[] = [];

  public ngAfterViewInit() {
    this.setNativeElement();
    this.editor = new MediumEditor(this.editable.nativeElement, {
      buttonLabels: "fontawesome",
      toolbar: {
        buttons: [
          "bold",
          "italic",
          "underline",
          "anchor",
          "justifyLeft",
          "justifyCenter",
          "justifyRight"
        ]
      },
      placeholder: {
        text: this.schema.placeholder
      }
    });

    const onEditableInput = () => (this.value = this.editor.getContent(0));
    this._subscriptions.push({
      event: "editableInput",
      listener: onEditableInput
    });
    this.editor.subscribe("editableInput", onEditableInput);

    const onKeyPress = e => this.onKeypress(e);
    this._subscriptions.push({
      event: "editableKeypress",
      listener: onKeyPress
    });
    this.editor.subscribe("editableKeypress", e => this.onKeypress(e));

    const onKeydown = e => this.onKeydown(e);
    this._subscriptions.push({ event: "editableKeydown", listener: onKeydown });
    this.editor.subscribe("editableKeydown", onKeydown);

    const onKeyup = e => this.onKeyup(e);
    this._subscriptions.push({ event: "editableKeyup", listener: onKeyup });
    this.editor.subscribe("editableKeyup", onKeyup);

    const onFocus = e => this.onFocus(e);
    this._subscriptions.push({ event: "focus", listener: onFocus });
    this.editor.subscribe("focus", onFocus);

    const onBlur = e => this.onBlur(e);
    this._subscriptions.push({ event: "blur", listener: onBlur });
    this.editor.subscribe("blur", onBlur);

    this.onInit(this);
  }

  public ngOnDestroy() {
    this._subscriptions.forEach(s =>
      this.editor.unsubscribe(s.event, s.listener)
    );

    this.editor.destroy();
  }

  public onValueSetted(new_value: string) {
    this.editor.setContent(new_value, 0);
  }

  public getRows(): number {
    return (<FormGridWithRows>this.schema.grid).rows;
  }
}
